/* eslint-disable camelcase */
import React from 'react'
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  IconButton,
} from '@material-ui/core'
import ArrowUpward from '@material-ui/icons/ArrowUpward'
import NullIcon from '@material-ui/icons/Remove'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { Link } from 'react-router-dom'
import colors from '../../../../assets/colors'
import Icon from '@mdi/react'
import { mdiMagnifyExpand } from '@mdi/js'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import classNames from 'classnames'
import { exportFormatedMoney } from '../../../../util/utils'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    border: `1px solid ${colors.graylight}`,
    color: colors.primary,
    fontSize: '13px',
    borderRadius: '10px',
    padding: '16px 18px',
  },
  finIcon: {
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 30,
    fontWeight: 700,
    color: colors.primary,
  },

  finValue: { color: colors.primary },

  subTitle: {
    fontWeight: 'bold',
    fontSize: '14px',
  },

  cardContent: {
    padding: 0,
    margin: 0,
    display: 'flex',
    paddingBottom: '0 !important',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'start',
    gap: '12px',
  },
  qtd: {
    fontWeight: 700,
    fontSize: '30px',
  },
  avatar: {
    backgroundColor: colors.error,
    height: 56,
    width: 56,
  },
  differenceIcon: {
    color: colors.sucess,
  },
  nullIcon: {
    color: colors.gray,
  },
  differenceValue: {
    color: colors.sucess,
    marginRight: theme.spacing(1),
  },
  noDifference: {
    color: colors.graylight,
    marginRight: theme.spacing(1),
    fontSize: '19px',
    lineHeight: '19px',
    fontWeight: 700,
  },
  today: {
    fontWeight: 400,
    fontSize: '14px',
  },
  footer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    textAlign: 'start',
    gap: '4px',
  },
}))

const ConcludedReceivablesCard = ({
  name,
  qtd = 0,
  receivable,
  redirectLink,
}) => {
  const classes = useStyles()

  return (
    <Grid>
      <Card className={classes.root} elevation={0}>
        <CardContent className={classes.cardContent}>
          <Grid container>
            <Grid item xs={12}>
              <Box className={classes.header}>
                <Typography className={classes.finIcon}>{qtd}</Typography>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography>{name}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      className={classNames(classes.finValue, classes.subTitle)}
                    >
                      {exportFormatedMoney(receivable)}
                    </Typography>
                  </Grid>
                </Grid>
                <Box
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: 'auto',
                    flex: 1,
                  }}
                >
                  <IconButton
                    variant="contained"
                    component={Link}
                    to={redirectLink}
                    style={{
                      padding: 0,
                    }}
                  >
                    <Icon
                      path={mdiMagnifyExpand}
                      size={1}
                      color={colors.graylight}
                    />
                  </IconButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}

export default ConcludedReceivablesCard
